import {tAsString} from "../../../../../common/helpers/react/text/tAsString";
import {TextInput} from "@sabre/spark-react-core";
import {KEY} from "../../../../../common/helpers/id/KEY";
import {MessageStatus} from "@sabre/spark-react-core/types";
import React, {RefObject} from "react";
import {Subject} from "rxjs";
import {useControllers} from "../../../../../common/helpers/react/hooks/useControllers";

export type EmulatePccModalData = {
    errorMessage?: string,
    inputRef: RefObject<HTMLInputElement>,
    pcc?: string
}

export type EmulatePccModalProps = {
    channel: Subject<EmulatePccModalData>
}

export default function EmulatePccModal(props: EmulatePccModalProps): JSX.Element {
    const data = props.channel.useState();
    const authInfo = useControllers().auth.getAuthInfo$().useState();

    return (
        data
            ? <>
                <p>
                    {tAsString('ENTER_PCC_FOR_ON_BEHALF_OF')}
                </p>
                <p>
                    <TextInput
                        maxLength={7}
                        className={'qa-on-behalf-of-pcc-input'}
                        autoFocus={true}
                        defaultValue={data.pcc}
                        key={KEY(data.errorMessage)}
                        ref={data.inputRef}
                        name={'pcc'}
                        label={tAsString('PCC')}
                        placeholder={authInfo?.pccsStatus?.pcc}
                        status={data.errorMessage ? MessageStatus.ERROR : undefined}
                        statusMessage={data.errorMessage}
                    />
                </p>
            </>
            : <></>
    )
}